// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDk2uCoIwoaBRvbvVJ793YbyWa3Kax7NoY",
  authDomain: "theralloswedding.firebaseapp.com",
  projectId: "theralloswedding",
  storageBucket: "theralloswedding.firebasestorage.app",
  messagingSenderId: "672310956965",
  appId: "1:672310956965:web:45b45b457c54e4e15b0e4c",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// Connect to Firestore emulator
if (window.location.hostname === "localhost") {
  connectFirestoreEmulator(db, "localhost", 8080);
}

export { app, db };
